import { Link } from 'react-router-dom';
import Image404 from '../../assets/images/404.svg';
import { AppLayout } from '../../containers/dashboard/AppLayout';

export const Error = () => {
  return (
    <>
      <AppLayout />
      <div className='error-page'>
        <picture>
          <img src={Image404} alt='404' />
        </picture>
        <h1 className='font-h1-regular'>Page not found</h1>
        <Link to='/' className='button-primary'>
          Back to Dashboard
        </Link>
      </div>
    </>
  );
};
